import { useCallback } from "react"
import useApiClient from "./use_api_client"

export default function useApiAction(options = {}) {
  const path = options.path
  const version = options.version || "2018-08-01"
  const defaultData = options.data || {}
  const app = options.app || "registrations"
  const client = useApiClient(app, version)

  const run = useCallback(
    function(attributes, data = {}) {
      return client.post({
        url: path,
        data: {
          ...defaultData,
          ...data,
          data: { attributes }
        }
      })
    },
    [client, path, defaultData]
  )

  return { run }
}
